import { SchedulerHtLuSurgeonsSettings } from '@lp/features/Scheduler';
import { SchedulerSettingsPageHeader } from '@lp/features/Scheduler/components';

const SCHEDULE_BACK_LINK_PATH = '/schedule/s-htlu';

export const SHtLuSchedulerSettings = () => {
  return (
    <div className="flex flex-col p-6 gap-6 min-h-full">
      <SchedulerSettingsPageHeader backLinkPath={SCHEDULE_BACK_LINK_PATH} />
      <SchedulerHtLuSurgeonsSettings scheduleBackPath={SCHEDULE_BACK_LINK_PATH} />
    </div>
  );
};
